import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useOktaAuth } from '@okta/okta-react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { clearAuth } from '@/store/slices/authSlice';
import logger from '@/utils/Logger';

export const useAuth = () => {
  const { oktaAuth } = useOktaAuth();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isAuthenticated, user, isLoading } = useAppSelector((state) => state.auth);

  const login = useCallback(() => {
    logger.info('Initiating login redirect');
    oktaAuth.setOriginalUri(location.pathname + location.search);
    oktaAuth.signInWithRedirect();
  }, [oktaAuth, location.pathname, location.search]);

  const logout = useCallback(() => {
    oktaAuth.signOut().then(() => {
      dispatch(clearAuth());
    });
  }, [oktaAuth, dispatch]);

  return { isAuthenticated, user, isLoading, login, logout };
};

export default useAuth;
